export default __webpack_public_path__ + "static/media/faq-icon.92355472.svg";